import { render, staticRenderFns } from "./UserFrame.vue?vue&type=template&id=4d71d2b5&"
import script from "./UserFrame.vue?vue&type=script&lang=js&"
export * from "./UserFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports